<div #journeySection class="journey-section">
  <div class="main-content">
    @if (section.isExpandable || isAdmin) {
      <div class="icon-container">
        <i
          (click)="toggleExpand()"
          class="toggle-icon bi"
          [ngClass]="expanded ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </div>
    }

    <div
      class="step-content"
      [ngClass]="{
        'extra-padding': !section.isExpandable && !isAdmin,
      }"
    >
      <h3
        [ngClass]="{
          'extra-bold': expanded,
        }"
      >
        {{ section.title }}
      </h3>
      <p>{{ section.description }}</p>
      <div class="status-and-appointment">
        @if (isAdmin) {
          <div ngbDropdown class="d-inline-block">
            <button
              class="status-badge"
              [class.editable]="isAdmin"
              ngbDropdownToggle
              [ngClass]="{
                'not-started': section.currentStatus === 'Not Started',
                'not-scheduled': section.currentStatus === 'Not Scheduled',
                'in-progress': section.currentStatus === 'In Progress',
                'under-review': section.currentStatus === 'Under Review',
                scheduled: section.currentStatus === 'Scheduled',
                completed: section.currentStatus === 'Completed',
                denied: section.currentStatus === 'Denied',
                approved: section.currentStatus === 'Approved',
              }"
              [disabled]="isStatusUpdating"
            >
              @if (!isStatusUpdating) {
                <span>
                  {{ section.currentStatus }}
                </span>
              } @else {
                <span> Updating... </span>
              }
            </button>

            <div ngbDropdownMenu>
              <button
                *ngFor="let status of statusOptions"
                class="dropdown-item"
                (click)="updateStatus(status)"
                [class.selected]="status === section.currentStatus"
              >
                {{ status }}
              </button>
            </div>
          </div>
        } @else {
          <div
            class="status-badge"
            [ngClass]="{
              'not-started': section.currentStatus === 'Not Started',
              'not-scheduled': section.currentStatus === 'Not Scheduled',
              'in-progress': section.currentStatus === 'In Progress',
              'under-review': section.currentStatus === 'Under Review',
              scheduled: section.currentStatus === 'Scheduled',
              completed: section.currentStatus === 'Completed',
              denied: section.currentStatus === 'Denied',
              approved: section.currentStatus === 'Approved',
            }"
          >
            {{ section.currentStatus }}
          </div>
        }

        @if (expanded && section.appointments.length > 0) {
          <div class="appointments-container">
            <div class="appointment-heading-container">
              <h5 class="appointment-heading">Appointment Details</h5>
              @if (isAdmin) {
                <i
                  (click)="addAppointment(section)"
                  class="bi bi-plus-circle add-icon"
                ></i>
              }
            </div>
            @for (appointment of section.appointments; track appointment) {
              <div class="appointment">
                <div class="appointment-details-container">
                  <p class="appointment-text">
                    <i class="appointment-icon bi bi-calendar-event"></i>
                    {{ this.formatDate(appointment.date, appointment.time) }}
                  </p>
                  @if (isAdmin) {
                    <div class="appointment-actions">
                      <i
                        (click)="updateAppointment(appointment, section)"
                        class="bi bi-pencil edit-icon"
                      ></i>
                      <i
                        (click)="deleteAppointment(appointment, section)"
                        class="bi bi-trash delete-icon"
                      ></i>
                    </div>
                  }
                </div>

                <p class="appointment-text">
                  <i class="appointment-icon bi bi-geo-alt-fill"></i>
                  {{ appointment.location }}
                </p>
                @if (appointment.notes && appointment.notes.trim().length > 0) {
                  <p>
                    <i class="appointment-icon bi bi-chat-left"></i>
                    {{ appointment.notes }}
                  </p>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="step-indicator">
      <div class="vertical-progress-tracker">
        <ul class="list-unstyled">
          <li class="progress-step d-flex align-items-center">
            <div class="pill-container">
              @if (!isFirstSection) {
                <div
                  class="top-vertical-line"
                  [ngClass]="{
                    'top-vertical-line-default':
                      section.currentStatus === 'Not Started',
                    'top-vertical-line-active':
                      section.currentStatus === 'In Progress',
                    'top-vertical-line-completed':
                      section.currentStatus === 'Completed' ||
                      section.currentStatus === 'Approved' ||
                      section.currentStatus === 'Denied',
                  }"
                ></div>
              }
              <div
                class="pill"
                [ngClass]="{
                  'step-default': section.currentStatus === 'Not Started',
                  'step-active': section.currentStatus === 'In Progress',
                  'step-completed':
                    section.currentStatus === 'Completed' ||
                    section.currentStatus === 'Approved' ||
                    section.currentStatus === 'Denied',
                }"
              >
                <i
                  *ngIf="
                    section.currentStatus === 'Completed' ||
                    section.currentStatus === 'Approved' ||
                    section.currentStatus === 'Denied'
                  "
                  class="bi bi-check-lg"
                  style="font-size: 1.5rem"
                ></i>
                <div
                  class="inner-circle"
                  [ngClass]="{
                    'inner-circle-default':
                      section.currentStatus === 'Not Started',
                    'inner-circle-active':
                      section.currentStatus === 'In Progress',
                    'inner-circle-completed':
                      section.currentStatus === 'Completed' ||
                      section.currentStatus === 'Approved' ||
                      section.currentStatus === 'Denied',
                  }"
                ></div>
              </div>
              @if (!isLastSection) {
                <div
                  #expandedLine
                  class="vertical-line"
                  [ngClass]="{
                    'bottom-vertical-line-default':
                      section.currentStatus === 'Not Started',
                    'bottom-vertical-line-active':
                      section.currentStatus === 'In Progress',
                    'bottom-vertical-line-completed':
                      section.currentStatus === 'Completed' ||
                      section.currentStatus === 'Approved' ||
                      section.currentStatus === 'Denied',
                    'expanded-line': expanded === true,
                  }"
                ></div>
              }
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- @if (expanded) { -->
  <div
    class="expandable-content"
    [ngClass]="{ expanded: expanded }"
    #expandableContent
  >
    @if (!isAdmin) {
      <div class="content-text">
        <p [innerHTML]="section.content"></p>
      </div>
      @if (section.documents && section.documents.length > 0) {
        <div class="action-header-donor">
          <div class="notes-container">
            <div class="notes-heading-container">
              <h4 class="response-heading-donor">Download Documents</h4>
              <i class="bi bi-download download-icon"></i>
            </div>
            @if (isFetchingDocuments) {
              <div class="text-center mt-3">
                <span
                  class="spinner-border"
                  role="status"
                  aria-hidden="true"
                ></span>
                <p>Refreshing documents...</p>
              </div>
            } @else {
              <ul class="document-list">
                <li *ngFor="let doc of section.documents" class="document-item">
                  <div class="document-content">
                    <a (click)="generateDownloadUrl(doc)" class="document-link">
                      {{ doc.fileName }}
                    </a>
                    <span
                      *ngIf="loadingDocId === doc.id"
                      class="spinner-border spinner-border-sm text-primary ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                </li>
              </ul>
            }
          </div>
        </div>
      }
    } @else {
      @if (this.isQuestionnaireSection && paginatedResponses) {
        <div class="action-header">
          <h4 class="response-heading">Donor's Response</h4>
          <i class="bi bi-card-text"></i>
        </div>

        <div class="d-flex justify-content-end mb-3">
          <input
            type="text"
            class="form-control table-search-box"
            placeholder="Search responses..."
            [(ngModel)]="searchQuery"
            (input)="filterResponses()"
          />
        </div>

        @if (paginatedResponses.length > 0) {
          <div class="table-container">
            <table
              class="table table-bordered table-striped response-table"
              [class.has-section]="
                this.comprehensiveQuestionnaireSection === section.sectionId
              "
            >
              <thead>
                <tr>
                  @if (
                    this.comprehensiveQuestionnaireSection === section.sectionId
                  ) {
                    <th scope="col" class="section-col">Section</th>
                  }
                  <th scope="col" class="question-col">Question</th>
                  <th scope="col" class="answer-col">Answer</th>
                </tr>
              </thead>
              <tbody>
                @for (response of paginatedResponses; track response) {
                  <tr>
                    @if (
                      this.comprehensiveQuestionnaireSection ===
                      section.sectionId
                    ) {
                      <td class="section-col">{{ response.sectionName }}</td>
                    }
                    <td class="question-col">{{ response.questionText }}</td>
                    <td class="answer-col">
                      <div
                        class="answer-text"
                        [textContent]="getAnswerDisplayText(response) || 'N/A'"
                      ></div>

                      @if (canTranslateResponse(response)) {
                        <div class="translation-tools">
                          @if (getTranslationState(response)?.translatedText) {
                            <div class="translated-answer">
                              <div class="translated-answer-label">
                                English translation
                              </div>
                              <div
                                class="translated-answer-text"
                                [textContent]="getTranslatedDisplayText(response)"
                              ></div>
                            </div>
                          } @else {
                            <button
                              type="button"
                              class="btn btn-sm translate-answer-btn"
                              [disabled]="getTranslationState(response)?.loading"
                              (click)="translateResponse(response)"
                            >
                              @if (getTranslationState(response)?.loading) {
                                Translating...
                              } @else {
                                Translate to English
                              }
                            </button>
                          }

                          @if (getTranslationState(response)?.error) {
                            <div class="translation-error">
                              {{ getTranslationState(response)?.error }}
                            </div>
                          }
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>

            <!-- Pagination -->
            <nav aria-label="Questionnaire Responses Pagination">
              <ngb-pagination
                [collectionSize]="totalResponses"
                [(page)]="currentPage"
                [pageSize]="pageSize"
                [maxSize]="5"
                (pageChange)="onPageChange($event)"
              ></ngb-pagination>
            </nav>
          </div>
        } @else {
          <div class="no-responses-text">No recorded responses yet</div>
        }
      } @else {
        <!-- PROVIDER -->
        @if (providerSections.includes(section.title.toLowerCase())) {
          @if (section.practitioners.length > 0) {
            <div class="action-header">
              <h4 class="response-heading">
                Provider:
                <span style="color: #008ad5">
                  {{ section.practitioners[0].name }}
                </span>

                <!-- @if (section.practitioners[0].qualification) {
                  ({{ section.practitioners[0].qualification }})
                } -->
              </h4>

              <div class="practitioner-actions">
                <i
                  (click)="updatePractitioner(section)"
                  class="bi bi-pencil pencil-icon"
                ></i>
                @if (this.deletingPractitioner) {
                  <span
                    class="spinner-border spinner-border-sm text-primary"
                  ></span>
                } @else {
                  <i
                    (click)="deletePractitioner(section)"
                    class="bi bi-trash delete-icon"
                  ></i>
                }
              </div>
            </div>
          } @else {
            <div class="action-header" (click)="addPractitioner(section)">
              <h4 class="response-heading">Add Provider</h4>
              <i class="bi bi-plus-circle add-icon"></i>
            </div>
          }
        }

        <!-- APPOINTMENT -->
        @if (section.appointments.length < 1) {
          <div class="action-header" (click)="addAppointment(section)">
            <h4 class="response-heading">Schedule</h4>

            <i class="bi bi-calendar-plus"></i>
          </div>
        }
      }
      <div class="action-header">
        @if (section.documents && section.documents.length > 0) {
          <div class="notes-container">
            <div class="notes-heading-container">
              <h4 class="response-heading">Documents</h4>
              <i
                class="bi bi-upload upload-icon"
                (click)="uploadDocument()"
              ></i>
            </div>
            @if (isFetchingDocuments) {
              <div class="text-center mt-3">
                <span
                  class="spinner-border"
                  role="status"
                  aria-hidden="true"
                ></span>
                <p>Refreshing documents...</p>
              </div>
            } @else {
              <ul class="document-list">
                <li *ngFor="let doc of section.documents" class="document-item">
                  <div class="document-content">
                    <a (click)="generateDownloadUrl(doc)" class="document-link">
                      {{ doc.fileName }}
                    </a>
                    <span
                      *ngIf="loadingDocId === doc.id"
                      class="spinner-border spinner-border-sm text-primary ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div class="document-actions">
                    @if (doc.isLoading) {
                      <span
                        class="spinner-border spinner-border-sm text-primary"
                      ></span>
                    } @else {
                      @if (!this.isQuestionnaireSection) {
                        <input
                          class="checkbox-action"
                          type="checkbox"
                          [checked]="doc.sharedWithDonor"
                          (change)="toggleShareWithDonor(doc, $event)"
                        />
                      }
                    }

                    @if (!this.isQuestionnaireSection) {
                      <label class="checkbox-label">Share with Donor</label>
                    }
                    @if (deletingDocId === doc.id) {
                      <i
                        class="spinner-border spinner-border-sm text-danger ms-2"
                        role="status"
                      ></i>
                    } @else {
                      <i
                        class="bi bi-trash delete-icon"
                        (click)="deleteDocument(doc)"
                      ></i>
                    }
                  </div>
                </li>
              </ul>
            }
          </div>
        } @else {
          <h4 class="response-heading">Add Documents</h4>
          <i class="bi bi-upload upload-icon" (click)="uploadDocument()"></i>
        }
      </div>
      <div class="action-header">
        @if (hasNotesOfType("Note", section.notes)) {
          <div class="notes-container">
            <div class="notes-heading-container">
              <h4 class="response-heading">Notes</h4>
              <i
                class="bi bi-pencil pencil-icon"
                (click)="addOrEditNote('Note', section)"
              ></i>
            </div>
            @if (this.noteContent.trim() !== "") {
              <quill-editor
                class="editor"
                [readOnly]="true"
                [modules]="quillModules"
                [(ngModel)]="this.noteContent"
              >
              </quill-editor>
            }
          </div>
        } @else {
          <h4 class="response-heading">Add Notes</h4>
          <i
            class="bi bi-plus-circle add-icon"
            (click)="addOrEditNote('Note', section)"
          ></i>
        }
      </div>
      <div class="action-header">
        @if (hasNotesOfType("Summary", section.notes)) {
          <div class="notes-container">
            <div class="notes-heading-container">
              <h4 class="response-heading">Summary and Recommendations</h4>
              <i
                class="bi bi-pencil pencil-icon"
                (click)="addOrEditNote('Summary', section)"
              ></i>
            </div>
            @if (this.summaryContent.trim() !== "") {
              <quill-editor
                class="editor"
                [readOnly]="true"
                [modules]="quillModules"
                [(ngModel)]="this.summaryContent"
              >
              </quill-editor>
            }
          </div>
        } @else {
          <h4 class="response-heading">Add Summary and Recommendations</h4>
          <i
            class="bi bi-plus-circle add-icon"
            (click)="addOrEditNote('Summary', section)"
          ></i>
        }
      </div>
    }
  </div>
  <!-- } -->
</div>
